/* @ngInject */
export default function ExternalSearchExecutionController($scope, $routeParams, $location, SearchExecutorService, ParametricSearchService, CacheService) {
    $scope.externalQuery = window.decodeURIComponent($routeParams.query);

    if ($scope.externalQuery) {

        if ($scope.externalQuery.length >= 2) {
            // If parmIds are passed in, then we want to send it to ParametricSearchService()
            if ($location.search().parmValueIds) {
                ParametricSearchService.searchParameterValuesBySleuth($location.search().parmValueIds, function searchDef(definition) {
                    let possibleFoundDefinition = null;
                    if ($location.search().id) {
                        if (definition.id == $location.search().id) {
                            possibleFoundDefinition = definition;
                        } else if (definition.childDefinitions.length > 0) {
                            for (var i = 0; i < definition.childDefinitions.length; ++i) {
                                possibleFoundDefinition = searchDef(definition.childDefinitions[i]);
                                if (possibleFoundDefinition) {
                                    CacheService.getParentDefinition().unshift(definition);
                                    break;
                                }
                            }
                        }
                        return possibleFoundDefinition;
                    }
                    return definition;
                });
            }
            // Normal search handling: SearchExecutorService()
            else {
                CacheService.storeOriginalQueryInput($scope.externalQuery);

                SearchExecutorService.searchKeyWordsBySleuth($scope.externalQuery, function searchDef(definition) {
                    var possibleFoundDefinition = null;
                    if ($location.search().id) {
                        if (definition.id == $location.search().id) {
                            possibleFoundDefinition = definition;
                        } else if (definition.childDefinitions.length > 0) {
                            for (var i = 0; i < definition.childDefinitions.length; ++i) {
                                possibleFoundDefinition = searchDef(definition.childDefinitions[i]);
                                if (possibleFoundDefinition) {
                                    CacheService.getParentDefinition().unshift(definition);
                                    break;
                                }
                            }
                        }
                        return possibleFoundDefinition;
                    }
                    return definition;
                });
            }
        }
    }
}

